// Phase 13 — Add-to-Calendar URL builders.
// Google Calendar uses a "template" URL; Apple/Outlook use the .ics download
// served by the backend. Outlook Web has its own deep-link.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function fmtUTC(iso) {
  const dt = new Date(iso);
  return dt.toISOString().replace(/[-:]|\.\d{3}/g, "");
}

function endIso(event) {
  const minutes = event.duration_minutes || 60;
  return new Date(new Date(event.starts_at_utc).getTime() + minutes * 60000).toISOString();
}

export function googleCalendarUrl(event) {
  const details = [event.description || "", event.zoom_url ? `Join: ${event.zoom_url}` : ""]
    .filter(Boolean)
    .join("\n\n");
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: event.title || "Live Event",
    dates: `${fmtUTC(event.starts_at_utc)}/${fmtUTC(endIso(event))}`,
    details,
    location: event.zoom_url || "",
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function outlookCalendarUrl(event) {
  const params = new URLSearchParams({
    path: "/calendar/action/compose",
    rru: "addevent",
    subject: event.title || "Live Event",
    startdt: event.starts_at_utc,
    enddt: endIso(event),
    body: event.description || "",
    location: event.zoom_url || "",
  });
  return `https://outlook.live.com/calendar/0/deeplink/compose?${params.toString()}`;
}

export function icsUrl(event) {
  return `${BACKEND_URL}/api/live-events/${event.id}/ics`;
}
